export default function getPassengerStatus(passenger) {
  const awaitingPickupStatus = 'AwaitingPickup';
  const onBoardStatus = 'OnBoard';
  const voyageCompleteStatus = 'VoyageComplete';
  const notSetStatus = 'NotSet';

  const { pickupDateTimeLt, dropOffDateTimeLt } = passenger;
  let result = notSetStatus;

  if (!pickupDateTimeLt && !dropOffDateTimeLt) result = awaitingPickupStatus;
  else if (pickupDateTimeLt && !dropOffDateTimeLt) result = onBoardStatus;
  else if (pickupDateTimeLt && dropOffDateTimeLt) result = voyageCompleteStatus;

  return result;
}
